import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  row: (props) => ({
    background: '#fff',
    cursor: (props as any).cursor,
    '&:hover': {
      background: (props as any).cursor === 'pointer' ? '#f7f7f7' : '#fff',
    },
  }),
  cell: {
    padding: '12px 10px',
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
    wordBreak: 'break-word',
    [theme.breakpoints.down(theme.size.sm)]: {
      border: 0,
    },
  },
  last: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  overflow: {
    display: 'inline-block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
  },
}));
